import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
    const { user, checked, register } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    if (checked && user) return <Navigate to="/" replace />;

    const handle = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        const res = await register(email.trim(), password, name.trim());
        setBusy(false);
        if (res.ok) navigate("/");
        else setErr(res.error);
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6" data-testid="register-page">
            <form onSubmit={handle} className="w-full max-w-sm" data-testid="register-form">
                <div className="font-serif text-3xl mb-1 text-center">
                    <span className="gold">T</span>rade With <span className="gold">P</span>urpose
                </div>
                <p className="text-sm text-zinc-500 mb-8 text-center">Create your private command center.</p>

                <label className="caption">Name (optional)</label>
                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    data-testid="register-name"
                    className="mt-2 mb-5 w-full bg-[#18181B] border border-white/10 rounded-md px-3 py-2.5 text-sm focus:border-[#D4AF37]/60"
                    placeholder="Your name"
                />
                <label className="caption">Email</label>
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="register-email"
                    className="mt-2 mb-5 w-full bg-[#18181B] border border-white/10 rounded-md px-3 py-2.5 text-sm focus:border-[#D4AF37]/60"
                    placeholder="you@example.com"
                />
                <label className="caption">Password (min 6 chars)</label>
                <input
                    type="password"
                    required
                    minLength={6}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="register-password"
                    className="mt-2 mb-5 w-full bg-[#18181B] border border-white/10 rounded-md px-3 py-2.5 text-sm focus:border-[#D4AF37]/60"
                />

                {err && (
                    <div className="mb-4 px-3 py-2 bg-[#B95050]/10 border border-[#B95050]/30 rounded-md text-sm text-[#E8A5A5]" data-testid="register-error">
                        {err}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={busy}
                    data-testid="register-submit"
                    className="w-full bg-[#D4AF37] text-[#0E0E10] font-medium px-4 py-2.5 rounded-md hover:bg-[#B3922E] transition-colors disabled:opacity-50"
                >
                    {busy ? "Creating..." : "Create account"}
                </button>
                <div className="mt-6 text-center text-sm text-zinc-500">
                    Already registered?{" "}
                    <Link to="/login" className="text-[#D4AF37] hover:underline" data-testid="register-login-link">
                        Sign in
                    </Link>
                </div>
            </form>
        </div>
    );
}
